import { render, staticRenderFns } from "./problem-edit-dic.vue?vue&type=template&id=b43dde0e&scoped=true&"
import script from "./problem-edit-dic.vue?vue&type=script&lang=js&"
export * from "./problem-edit-dic.vue?vue&type=script&lang=js&"
import style0 from "./problem-edit-dic.vue?vue&type=style&index=0&id=b43dde0e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43dde0e",
  null
  
)

export default component.exports